import { IconProps } from '../IconProps';

function Dots({ size = 48 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      version="1.1"
      className="text-blue-500"
      id="L4"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 0 0"
      xmlSpace="preserve">
      <circle fill="currentColor" stroke="none" cx="10" cy="50" r="10">
        <animate attributeName="opacity" dur="2s" values="0;1;0" repeatCount="indefinite" begin="0.1" />
      </circle>
      <circle fill="currentColor" stroke="none" cx="50" cy="50" r="10">
        <animate attributeName="opacity" dur="2s" values="0;1;0" repeatCount="indefinite" begin="0.2" />
      </circle>
      <circle fill="currentColor" stroke="none" cx="90" cy="50" r="10">
        <animate attributeName="opacity" dur="2s" values="0;1;0" repeatCount="indefinite" begin="0.3" />
      </circle>
    </svg>
  );
}

export { Dots };
